import {
  ReadOnly,
  useEntityPermission,
  useMasterData,
} from '@ui-framework/index';
import { forwardRef, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import AutoComplete from './AutoComplete';

/*
 * Dependency:
 *   File: sxcl-frontend-app/packages/frontend/src/product-framework/components/SJFormHandler/SJFormHelper.js
 *   function: getValueByControl
 *  A single country added as a frontend metadata for static country  masterData?.frontendAppData.staticCountry
 */

const Countries = forwardRef(({ field, ...props }, ref) => {
  const name = props?.name ?? field?.name;
  const customConfig = {
    nameKey: 'countryName',
    valueKey: 'id',
    apiPath: 'countries',
    searchKey: 'countryName',
  };

  const masterData = useMasterData();

  const staticCountry = masterData?.frontendAppData?.staticCountry;

  const { nameKey, valueKey, apiPath, searchKey } = customConfig;

  const { getValues, setValue, control } = useFormContext();
  const { isHidden, isReadOnly } = useEntityPermission();

  const currentvalue = getValues(field?.name)?.label;

  if (isReadOnly(props?.permission, currentvalue)) {
    return <ReadOnly name={field?.name}>{currentvalue}</ReadOnly>;
  }

  if (isHidden(props?.permission)) {
    return <input type="hidden" name={field?.name} value={currentvalue} />;
  }

  if (staticCountry?.id) {
    const data = {
      label: staticCountry.label,
      value: staticCountry.id,
    };
    return (
      <Controller
        name={name}
        control={control}
        render={() => {
          useEffect(() => {
            // TODO: have to add this timeout hack, else setValue was not being set
            setTimeout(() => {
              if (!currentvalue) {
                setValue(name, data, { shouldDirty: true });
              }
            }, 1000);
          }, [name, setValue, currentvalue]);
          return <ReadOnly name={name}>{staticCountry.label}</ReadOnly>;
        }}
      />
    );
  }

  return (
    <AutoComplete
      ref={ref}
      nameKey={nameKey}
      valueKey={valueKey}
      apiPath={apiPath}
      searchKey={searchKey}
      field={field}
      {...props}
    />
  );
});

export default Countries;
